import o from "clsx";
import e from "react";
import { s as n } from "../../../../../RideIcon.module-BjMwOP4j.mjs";
function m({
  size: t = "small",
  accessibilityTitle: r = "ricon battery light",
  className: a,
  "data-testid": l
}) {
  const i = () => o(a, n["ride-icon"], {
    [n[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: i(), "data-testid": l }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      stroke: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    r && /* @__PURE__ */ e.createElement("title", null, r),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M37.335 18.875H26.165L22.165 30.875H26.165L21.165 42.875L36.165 26.9275H31.145L37.335 18.875Z",
        fill: "url(#paint0_linear_2527_1508)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M56 12H49.5C48.395 12 47.5 12.895 47.5 14V16H43.3275L40.255 20H54.0025V26H41.16L38.3525 28.9825L37.3975 30H54.0025V50H10V30H19.295L19.32 29.9275L20.63 26H10V20H22.63L23.32 17.9275L23.9625 16H16.5V14C16.5 12.895 15.605 12 14.5 12H8C6.895 12 6 12.895 6 14V56C6 58.205 7.795 60 10 60H54C56.205 60 58 58.205 58 56V14C58 12.895 57.105 12 56 12ZM54 56H10V54H54.0025V56H54Z",
        fill: "url(#paint1_linear_2527_1508)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_2527_1508",
        x1: "21.165",
        y1: "42.875",
        x2: "43.4081",
        y2: "27.8888",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#F81E42" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#FA6981" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_2527_1508",
        x1: "6",
        y1: "12",
        x2: "30.3467",
        y2: "71.345",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { offset: "0.272135", stopColor: "#34263B" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "0.658079", stopColor: "#13172C" })
    ))
  ));
}
export {
  m as RideIcBatteryLight
};
